import { render, staticRenderFns } from "./WelcomeBackModal.vue?vue&type=template&id=3ae9c3f0&scoped=true&"
import script from "./WelcomeBackModal.vue?vue&type=script&lang=ts&"
export * from "./WelcomeBackModal.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeBackModal.vue?vue&type=style&index=0&id=3ae9c3f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae9c3f0",
  null
  
)

export default component.exports